<template>
  <el-container :style="parent" class="parent">
    <el-footer>
      <h3 style="text-align: center">{{ formlist.enterpriseName }}</h3>
      <el-carousel height="200px">
        <el-carousel-item v-for="(item, index) in src" :key="index">
          <a :href="item.link">
            <el-image
              :src="decodeURIComponent(item.url)"
              style="width: 100%; height: 100%"
              fit="fill"
            ></el-image>
          </a>
        </el-carousel-item>
      </el-carousel>
    </el-footer>
    <el-row style="margin-top: 15px; padding: 5px 20px">
      <el-col :span="22" :offset="1">
        <div class="hater">溯源信息</div>
        <el-divider></el-divider>
        <!-- 第一次扫到正品码 -->
        <el-form
          ref="formlist"
          :model="formlist"
          style="text-align: left"
          v-show="dialogVisible"
          class="mainform"
          center
        >
          <!-- 溯源信息 -->
          <el-tag type="danger"
            >该产品是{{ formlist.enterpriseName }}生产的官方正品！</el-tag
          >
          <el-form-item
            label="产品图片:"
            label-width="85px"
            v-show="productimg"
          ></el-form-item>
          <el-form-item label-width="80px" v-show="productimg">
            <div>
              <el-image
                style="width: 80px; height: 60px"
                :src="decodeURIComponent(formlist.productPic)"
                :preview-src-list="[decodeURIComponent(formlist.productPic)]"
                fit="scale-down"
              >
                <div slot="error" class="image-slot" style="text-align: center">
                  <i class="el-icon-picture-outline" style="font-size: 46px"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
          <el-form-item
            label="产品名称:"
            label-width="85px"
            v-show="obj.product_name == 'true'"
          >
            <div>{{ formlist.product_name }}</div>
          </el-form-item>
          <el-form-item
            label="产品编码:"
            label-width="85px"
            v-show="obj.product_name == 'true'"
          >
            <div>{{ formlist.product_code }}</div>
          </el-form-item>
          <el-form-item
            label="追溯编码:"
            label-width="85px"
            v-show="obj.qrcode == 'true'"
          >
            <div>{{ formlist.qrcode }}</div>
          </el-form-item>
          <el-form-item
            label="首次扫码时间:"
            label-width="115px"
            v-show="obj.create_time == 'true'"
          >
            <div>{{ formlist.create_time }}</div>
          </el-form-item>
          <el-form-item label="扫码次数:" label-width="85px" v-show="obj.count == 'true'">
            <div>{{ formlist.count }}</div>
          </el-form-item>
          <el-form-item
            label="生产厂家:"
            label-width="85px"
            v-show="obj.enterpriseName == 'true'"
          >
            <div>{{ formlist.enterpriseName }}</div>
          </el-form-item>
          <el-form-item
            label="生产批次:"
            label-width="85px"
            v-show="obj.batchNo == 'true'"
          >
            <div>{{ formlist.batchNo }}</div>
          </el-form-item>
          <!--  -->
          <el-row class="demo-avatar demo-basic" style="margin: 10px 0" :gutter="20">
            <el-col :span="6" v-for="(item, i) in imglist" :key="i">
              <a :href="item.link">
                <el-image :src="decodeURIComponent(item.content)" style="height: 36px"></el-image>
              </a>
            </el-col>
          </el-row>
          <!-- 基础信息 -->
          <el-card class="box-card" v-show="wlistshow">
            <div slot="header" class="clearfix">
              <span style="color: #000">基础信息</span>
            </div>
            <div
              v-for="(item, i) in formlist.wlist"
              :key="i"
              class="text item"
              style="color: #000"
            >
              {{ `${item.columnTitle}：${item.columnValue}` }}
            </div>
          </el-card>
          <!-- 拓展属性 -->
          <el-divider></el-divider>
          <div v-show="packageLevel">
            您查询的是消费者扫产品的包装箱码，该产品相关信息如下:
          </div>
          <el-table
            border
            :data="this.formlist.extendList"
            style="width: 100%"
            v-show="packageLevel"
          >
            <el-table-column prop="columnTitle" label="产品信息"></el-table-column>
            <el-table-column prop="columnValue" label></el-table-column>
          </el-table>
          <!-- <el-card shadow="hover" class="fanwei" v-if="formlist.qrcodeFlows===null ? false:formlist.qrcodeFlows.length>0">
            <div slot="header" class="clearfix">
              <h4>物流信息</h4>
            </div>
            <el-form-item label="配送物流">
              <div v-show="formlist.hasfreightBillCode">
                {{ formlist.enterpriseName }}{{ formlist.from_warehouse }}出到{{
                  formlist.to_warehouse
                }}
              </div>
              <br />
              <el-timeline :reverse="false">
                <el-timeline-item
                  v-for="(item, index) in formlist.qrcodeFlows"
                  :key="index"
                  :timestamp="item.createTime"
                >
                  <div>单号：{{ item.orderNo }}</div>
                  <div>物流类型：{{ item.type }}</div>
                  <div>发货方：{{ item.shipper }}</div>
                  <div>发货地址：{{ item.shipperAddress }}</div>
                  <div>收货方：{{ item.shipto }}</div>
                  <div>收货地址：{{ item.shiptoAddress }}</div>
                </el-timeline-item>
              </el-timeline>
            </el-form-item>
          </el-card> -->
          <!-- 企业简介 -->
          <el-form-item
            label="企业简介:"
            label-width="85px"
            class="label_color_size"
          ></el-form-item>
          <el-form-item label-width="0px">
            <div>{{ content }}</div>
          </el-form-item>
          <div>
            <el-footer>
              <a :href="link2">
                <el-image :src="decodeURIComponent(photo6)" style="width: 100%; height: 100%"></el-image>
              </a>
            </el-footer>
          </div>
        </el-form>
        <!-- 扫到假货 -->
        <el-form
          ref="formlist"
          :model="formlist"
          label-width="140px"
          v-show="Visible"
          class="mainform"
        >
          <div>系统维护中</div>
        </el-form>
      </el-col>
    </el-row>
  </el-container>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          resdata: {},
        };
      },
    },
  },
  data() {
    return {
      srcurl: this.$base.dv + "/api/out/qrcodescantemplate/findcontentpic?picUrl=",
      //接口参数
      packageLevel: true,
      qrcode: "",
      imgsrc: "data:image/png;base64,",
      qlist: [],
      imglist: [],
      formlist: {},
      arrlist: [],
      // 全屏css
      parent: {
        height: "600px",
      },
      footer: {
        height: "200px",
      },
      // 基础数据
      src: [],
      link2: "javascript:;",
      content: "",
      dialogVisible: false,
      Visible: false,
      information: null,
      informationarr: null,
      wlistshow: false,
      obj: {},
      productimg: false,
      photo2: require("../../../assets/img/3.png"),
      photo3: require("../../../assets/img/3.png"),
      photo4: require("../../../assets/img/3.png"),
      photo5: require("../../../assets/img/3.png"),
      photo6: require("../../../assets/img/3.png"),
    };
  },
  mounted() {
    this.getheight();
    this.formlistget();
  },
  methods: {
    // 获取url参数
    // 获取浏览器高度
    getheight() {
      this.$data.parent.height =
        (window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight) + "px";
      console.log(this.parent.height);
    },
    // 跟据链接参数调接口 100001522019091710010000561V06GT12
    formlistget() {
      let response = this.data.resdata;
      console.log(response.data);
      // if (
      //   response.data.extendList
      // ) {
      //   this.packageLevel = true;
      // }
      this.formlist = response.data;
      if (this.formlist.ifForgery === false) {
        this.Visible = true;
      } else {
        this.dialogVisible = true;
      }
      // if (this.formlist.qrcodeFlows===null ? false:this.formlist.qrcodeFlows.length>0) {
      //   for (let i = 0; i < this.formlist.qrcodeFlows.length; i++) {
      //     switch (this.formlist.qrcodeFlows[i].type) {
      //       case 0:
      //         this.formlist.qrcodeFlows[i].type = "调拨出库";
      //         break;
      //       case 1:
      //         this.formlist.qrcodeFlows[i].type = "销售出库";
      //         break;
      //       case 2:
      //         this.formlist.qrcodeFlows[i].type = "出库单退货";
      //         break;
      //       case 3:
      //         this.formlist.qrcodeFlows[i].type = "借货出库";
      //         break;
      //       case 4:
      //         this.formlist.qrcodeFlows[i].type = "调拨入库";
      //         break;
      //       case 5:
      //         this.formlist.qrcodeFlows[i].type = "入库";
      //         break;
      //       case 6:
      //         this.formlist.qrcodeFlows[i].type = " 经销商入库";
      //         break;
      //       case 7:
      //         this.formlist.qrcodeFlows[i].type = "经销商跨级入库";
      //         break;
      //       case 8:
      //         this.formlist.qrcodeFlows[i].type = "拒收退货";
      //         break;
      //       case 9:
      //         this.formlist.qrcodeFlows[i].type = "销售退货";
      //         break;
      //       default:
      //         break;
      //     }
      //   }
      // }

      for (let i = 0; i < this.formlist.qlist.length; i++) {
        if (this.formlist.qlist[i].link == "") {
          this.formlist.qlist[i].link = "javascript:;";
        }
        switch (this.formlist.qlist[i].type) {
          case 3:
            this.src.push({
              url: this.formlist.qlist[i].content,
              link: this.formlist.qlist[i].link,
            });
            break;
          default:
            break;
        }
        switch (this.formlist.qlist[i].templateOrder) {
          case 2:
            this.imglist = this.formlist.qlist.slice(i, i + 4);
            break;
          case 6:
            this.content = this.formlist.qlist[i].content;
            break;
          case 7:
            this.link2 = this.formlist.qlist[i].link;
            this.photo6 =  this.formlist.qlist[i].content;
            break;
          default:
            break;
        }
      }
      if (this.formlist.productPic) {
        this.productimg = true;
      }
      this.qlist = this.formlist.qlist[5];

      //
      this.information = response.data.qlist[response.data.qlist.length - 1];
      this.informationarr = this.information.content.split(",");
      for (var i = 0; i < this.informationarr.length; i++) {
        var split = this.informationarr[i].split(":");
        this.obj[split[0].trim()] = split[1].trim();
      }
      if (this.formlist.wlist.length>0) {
        this.wlistshow = true;
      }
    },
  },
};
</script>
<style scoped>
.mainform {
  height: 60%;
}
.el-main {
  padding: 5px 20px 10px;
}
.el-header {
  height: 40px !important;
  font-size: 20px;
  background-color: #03a9f4;
  color: aliceblue;
  text-align: center;
  line-height: 40px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.el-footer {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  height: auto !important;
  margin-bottom: 0px;
  padding: 0 0px;
}
.el-form-item--mini.el-form-item {
  margin-bottom: 0px;
}
.el-form-item__label {
  text-align: left;
}
.hater {
  margin-top: 30px;
  font-size: 18px;
  font-weight: 600;
  color: #000000b3;
}
.el-divider--horizontal {
  margin: 10px 0;
}
.text {
  font-size: 12px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  margin: 10px 0;
  width: 100%;
}
.label_color_size .el-form-item__label {
  font-size: 18px;
  color: #52acff;
}
a {
  -webkit-tap-highlight-color: transparent;
  outline: none;
}
</style>
